import {Component, TemplateRef} from '@angular/core';
import {ICellRendererAngularComp} from 'ag-grid-angular';
import {ICellRendererParams} from 'ag-grid-community';
import {BsModalService} from 'ngx-bootstrap/modal';
import {TranslateModule} from '@ngx-translate/core';
import {NgClass, NgIf} from '@angular/common';
import {ITransaction} from './transactions/interface';
import {WhatQuestionComponent} from './what-is-it/what-question.component';
import {PopoverModule} from 'ngx-bootstrap/popover';

export interface IDescriptionCellParams extends ICellRendererParams {
  editComponent?: TemplateRef<any>;
  onChange?: (item: ITransaction) => void;
}

@Component({
  selector: 'app-tx-description-cell-renderer',
  template: `
      <span class="cursor-pointer text-decoration-underline-hover link-primary" (click)="editTx(item)">
          {{ item.description || 'N/A' }}
      </span>
  `,
  styles: [`
    .fon-size-20 {
      font-size: 20px;
    }
  `],
  standalone: true,
  imports: [
    TranslateModule,
  ],
})
export class DescriptionCellRendererComponent implements ICellRendererAngularComp {
  item: ITransaction;
  params: IDescriptionCellParams;

  agInit(params: IDescriptionCellParams): void {
    this.params = params;
    this.item = params.data;
  }

  refresh(params: ICellRendererParams<any>): boolean {
    return false;
  }

  editTx(transaction: ITransaction) {
    if (this.params.editComponent) {
      this.modalService.show(this.params.editComponent, {
        initialState: {
          // @ts-ignore
          transaction,
        },
      });
    }
  }

  constructor(
    private modalService: BsModalService,
  ) {
  }
}